import React from 'react';
import withRoot from './modules/withRoot';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';
import UserAdmin from './modules/components/UserAdmin';


const Page = () => (
    <React.Fragment>
        <AppAppBar />
        <UserAdmin />
        <AppFooter />
    </React.Fragment>
);

export default withRoot(Page);
